<template>
  <el-dialog :class="[currentTheme]" :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px" :append-to-body="true">
    <div class="main-table tableColumnSetting-div" style="height: 400px;width: 590px;margin: 5px">
      <el-table
        ref="columnSettingTable"
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        height="390"
        border>
        <el-table-column
          prop="columnName"
          label="列名称">
        </el-table-column>
        <el-table-column
          prop="isShow"
          label="是否显示">
          <template #default="scope">
            <div class="table-checkbox" style="text-align: center;">
              <el-checkbox v-model="scope.row.isShow" true-label="1" false-label="0"></el-checkbox>
            </div>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <div slot="footer" class="dialog-footer">
      <div class="fl">
        <el-checkbox v-model="isCheckAll" @click.native.stop="handleSelection()" true-label="1" false-label="0"></el-checkbox>&nbsp;显示全部列字段
      </div>
      <xr-button type="primary" @click.native="save()">确定</xr-button>
      <xr-button type="default" @click.native="dialogVisible = false">取消</xr-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
    //表格配置
    name: "tableColumn-setting",
    data() {
      return {
        dialogVisible: false,                   //是否显示
        dialogName: '表格配置',
        id: '',                                 //表格的ID
        isCheckAll: '1',                        //选择全部
        tableData: []                           //数据数组
      }
    },
    computed: {
      currentTheme() {
        return this.$store.getters.themeType; //获取当前的主题类型
      },
    },
    methods: {
      //初始化页面
      init(id, columns) {
        this.dialogVisible = true;
        this.isCheckAll = '1';
        this.id = id;
        let tableDate = [];
        for (let i = 0; i < columns.length; i++) {
          let temp = columns[i];
          if(temp.field == 'ck'){   //清除掉无用的内容
            continue;
          }
          let obj = new Object();
          obj['tableColumn'] = temp.field;
          obj['columnName'] = temp.title;
          obj['isShow'] = !!temp.isShow?temp.isShow:'1';
          tableDate.push(obj)
        }
        this.tableData = tableDate;
      },
      //checkbox选择事件
      handleSelection(){
        let isCheckAll = this.isCheckAll;
        for (let i = 0; i < this.tableData.length; i++) {
          let temp = this.tableData[i];
          if(isCheckAll == '1'){   //改变前的值，如果是1 ，是全不选
            temp.isShow = '0';
          }else{
            temp.isShow = '1';
          }
        }
        // this.tableData = tableDate;
      },
      //确认
      save() {
        let dataStr = JSON.stringify(this.tableData);
        localStorage.setItem('#' + this.id + '-table-column', dataStr);
        this.$emit('confirmMethod');
        this.dialogVisible = false;
      }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/XrTable/tableColumn-setting.vue